var map = {
	"./Infobild-Rahmennummer.jpg": 74414,
	"./add.svg": 72604,
	"./alert-red.svg": 41829,
	"./alert.svg": 69309,
	"./badge.svg": 75370,
	"./checkmark-big.svg": 9742,
	"./datepicker.svg": 98115,
	"./drop-arrow.svg": 95133,
	"./error.svg": 71043,
	"./flow-arrow-white.svg": 37856,
	"./flow-arrow.svg": 59438,
	"./identification.svg": 78536,
	"./insurance.svg": 76909,
	"./loader-big.gif": 94215,
	"./loader.gif": 371,
	"./question.svg": 55180,
	"./remove.svg": 50205,
	"./type-file.svg": 94174,
	"./type-pdf.svg": 36681,
	"./wallet.svg": 12618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;